'use client';

import { VictoryPie, VictoryLabel } from 'victory';

/**
 * Data structure for an individual pie chart item.
 */
export interface IPieChartItem {
  /** Description or statistical value for the item. */
  desc: string;
  /** The title or category name for the item. */
  title: string;
}

/**
 * Properties for the VictoryPieChart component.
 */
interface IPieChartDataProps {
  /** The central label for the pie chart. */
  label: string;
  /** Array of items to be displayed in the pie chart. */
  items?: IPieChartItem[];
}
/**
 * -----------------------------------------------------------------------------
 * This renders a pie-chart component to display statistical data.
 */
export function VictoryPieChart({ items, label }: IPieChartDataProps) {
  const pieChartItems = items?.map((item) => {
    const desc = item.desc.split(' ')[0];
    const stats = Number(desc?.replace('%', ''));
    return { x: item.title, y: stats };
  });

  return (
    <svg viewBox="0 0 400 400">
      <VictoryPie
        colorScale="blue"
        data={pieChartItems}
        height={400}
        innerRadius={98}
        labelRadius={120}
        standalone={false}
        style={{ labels: { fontSize: 10, fill: '#ccc' } }}
        width={400}
      />
      <VictoryLabel
        style={{ fontSize: 12 }}
        text={label}
        textAnchor="middle"
        x={200}
        y={200}
      />
    </svg>
  );
}
